import { render, staticRenderFns } from "./FacComponent.vue?vue&type=template&id=767bedce&scoped=true"
import script from "./FacComponent.vue?vue&type=script&lang=js"
export * from "./FacComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767bedce",
  null
  
)

export default component.exports